module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/components/devotee-list/devotee-list.component.css
// module id = ./src/app/admin/components/devotee-list/devotee-list.component.css
// module chunks = main